import React from 'react';

const StudentIconAttribution = () => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <span>
      Icons from
      <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
      {' '}
      by:
      {' '}
    </span>
    <a href="https://www.flaticon.com/authors/ultimatearm" title="ultimatearm">ultimatearm</a>
    {', '}
    <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a>
    {', and '}
    <a href="https://creativemarket.com/eucalyp" title="Eucalyp">Eucalyp</a>
  </div>
);

export default StudentIconAttribution;
